import {
  REQUEST_MONEY_NOT_FOUND,
  REQUEST_MONEY_INVALID_REQUEST,
  REQUEST_MONEY_SUCCESS,
  REQUEST_MONEY_FAILED,
  REQUEST_MONEY_CARD_NOT_FOUND,
  REQUEST_MONEY_OPERATION_NOT_PERMITTED,
  RESET_REQUEST_MONEY,
  LOADING_REQUEST_MONEY
} from "../types";

const initialState = {
  isLoading: false,
  notFound: false,
  failed: false,
  invalidRequest: false,
  cardNotFound: false,
  success: false,
  operationNotPermitted: false,
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_REQUEST_MONEY:
      return {
        ...state,
        isLoading: true,
        notFound: false,
        failed: false,
        invalidRequest: false,
        cardNotFound: false,
        success: false,
        operationNotPermitted: false,
        data: {}
      };
    case REQUEST_MONEY_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        notFound: true,
        failed: false,
        invalidRequest: false,
        cardNotFound: false,
        success: false,
        operationNotPermitted: false,
        data: {}
      };
    case REQUEST_MONEY_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        failed: false,
        invalidRequest: true,
        cardNotFound: false,
        success: false,
        operationNotPermitted: false,
        data: {}
      };

    case REQUEST_MONEY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        invalidRequest: false,
        failed: false,
        cardNotFound: false,
        success: true,
        operationNotPermitted: false,
        data: action.data
      };

    case REQUEST_MONEY_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        notFound: false,
        success: false,
        invalidRequest: false,
        cardNotFound: false,
        operationNotPermitted: false,
        data: {}
      };

    case REQUEST_MONEY_CARD_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        cardNotFound: true,
        success: false,
        notFound: false,
        invalidRequest: false,
        failed: false,
        operationNotPermitted: false,
        data: {}
      };

    case REQUEST_MONEY_OPERATION_NOT_PERMITTED:
      return {
        ...state,
        isLoading: false,
        cardNotFound: false,
        success: false,
        notFound: false,
        invalidRequest: false,
        failed: false,
        operationNotPermitted: true,
        data: {}
      };

    case RESET_REQUEST_MONEY:
      return (state = initialState);

    default:
      return state;
  }
};
